export default __webpack_public_path__ + "static/media/mentorship.c1d33fb0.png";